<template>
	<v-container fluid >
		<div class="bottom-buttons-outer">
			<v-btn @click="backClick" color="success">
				<v-icon small>fa-reply</v-icon>&nbsp;{{$t('buttons.back')}}
			</v-btn>
			<v-btn @click="saveClick" color="success">
				<v-icon small>fa-save</v-icon>&nbsp;{{$t('buttons.save')}}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex lg8 xs12>
				<v-card>
					<v-card-text>
						<v-layout row wrap>
							<v-flex xs12>
								<InputField :error="userValidation.first_name"
											:label="'* '+$t('fields.firstName')"
											v-model="user.first_name"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField
									:error="userValidation.last_name"
									:label="'* '+$t('fields.lastName')"
									v-model="user.last_name"></InputField>
							</v-flex>
							<v-flex xs12>
								<InputField
									:error="userValidation.email"
									:label="'* '+$t('fields.email')"
									v-model="user.email"></InputField>
							</v-flex>
							<v-flex v-if="user.id == 0" xs12>
								<InputField
									:error="userValidation.password"
									:label="'* '+$t('fields.password')"
									v-model="user.password"></InputField>
							</v-flex>
							<v-flex xs12>
								<Dropdown
									:ajax="true"
									:data="'user-roles'" :error="userValidation.user_role_id"
									:label="'* '+$t('fields.role')"
									v-model="user.user_role_id"></Dropdown>
							</v-flex>
							<v-flex xs12>
								<CheckBox
									:label="$t('fields.active')"
									v-model="user.active"></CheckBox>
							</v-flex>
						</v-layout>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
	import InputField from "./trinkets/InputField"
	import CheckBox from "./trinkets/CheckBox";
	import Dropdown from "./trinkets/Dropdown";

	export default {
		name: "UserAccount",
		components: {CheckBox, InputField, Dropdown},
		data: function () {
			return {
				user: {
					id: this.$route.params.id,
					first_name: '',
					last_name: '',
					email: '',
					password: '',
					user_role_id: null,
					active: true
				},
				userValidation: {
					id: '',
					first_name: '',
					last_name: '',
					email: '',
					password: '',
					user_role_id: null,
					active: ''
				},
				initialLoad: false,
				changesHappened: false
			}
		},
		watch: {
			user: {
				handler: function () {
					if (this.initialLoad) {
						this.changesHappened = true;
					}
				},
				deep: true
			},
		},
		methods: {
			backClick() {
				this.$router.go(-1);
			},
			saveClick() {
				let success = true;

				if (this.user.first_name == '') {
					success = false;
					this.userValidation.first_name = this.$t('alerts.fieldError');
				} else {
					this.userValidation.first_name = '';
				}

				if (this.user.last_name == '') {
					success = false;
					this.userValidation.last_name = this.$t('alerts.fieldError');
				} else {
					this.userValidation.last_name = '';
				}

				if (this.user.id == 0) {
					if (this.user.password.trim() == '') {
						success = false;
						this.userValidation.password = this.$t('alerts.fieldError');
					} else {
						if (this.user.password.length < 8) {
							success = false;
							this.userValidation.password = this.$t('alerts.passwordLength');
						} else {
							this.userValidation.password = '';
						}
					}
				}

				if (this.user.user_role_id == null) {
					success = false;
					this.userValidation.user_role_id = this.$t('alerts.fieldError');
				} else {
					this.userValidation.user_role_id = '';
				}

				if (this.user.email == '') {
					success = false;
					this.userValidation.email = this.$t('alerts.fieldError');
				} else {
					if (!this.$checkEmail(this.user.email)) {
						success = false;
						this.userValidation.email = this.$t('alerts.emailFailFormat');
					} else {
						this.userValidation.email = '';
					}
				}

				if (success) {
					let vm = this;
					let action = 'post';
					let addition = '';
					if (vm.user.id != 0) {
						action = 'put';
						addition = '/' + vm.user.id;
					}
					this.$APICall(action, 'users' + addition, this.user, (data, success) => {
						if (success) {
							vm.changesHappened = false;
							if (vm.user.id == 0) {
								vm.$notify(vm.$t('alerts.basicAdd'));
							} else {
								vm.$notify(vm.$t('alerts.basicUpdate'));
							}
							vm.$triggerReload();
							vm.backClick();
						} else {
							vm.$alert(vm.$t('alerts.userExists'));
						}
					});
				}
			}
		},
		mounted() {
			if (!this.$myStore.state.loggedIn) {
				this.$router.replace('login');
			}
			this.$setSubMenu('Settings');
			let vm = this;
			if (this.user.id != 0) {
				this.$APICall('get', 'users/' + this.user.id, {}, (data, success) => {
					if (success) {
						let usableData = JSON.parse(JSON.stringify(data));
						vm.$myStore.commit('setBreadcrumbs', [
							{text: vm.$t('modules.userAccounts'), href: '/#/user-accounts', disabled: false},
							{text: vm.user.email, href: '/#/user-accounts/' + vm.user.id, disabled: true}
						]);
						vm.$nextTick(() => {
							vm.initialLoad = true;
						});
						usableData.password_change = false;
						vm.user = usableData;
					}
				});
			} else {
				this.$myStore.commit('setBreadcrumbs', [
					{text: this.$t('modules.userAccounts'), href: '/#/user-accounts', disabled: false},
					{text: this.$t('modules.newUserAccount'), href: '/#/user-accounts/0', disabled: true}
				]);
				this.initialLoad = true;
			}
		},
		beforeRouteLeave(to, from, next) {
			if (this.changesHappened) {
				this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
					next(result);
				});
			} else {
				next(true);
			}
		}
	}
</script>

<style scoped>

</style>
